import { DesktopDialog, HubSheet, HubSheetActions } from "../AdminPortal/HubPwa";
import aa from "../AdminPortal/adminApp.module.css";

export function TrainerGroupRemoveDialog({
  open,
  groupName,
  onConfirm,
  onCancel,
  mobile = false,
}) {
  const title = "Снять с группы?";
  const body = (
    <p className={aa.hubSheetHint}>
      Тренер перестанет вести группу «{groupName}». Все её будущие занятия
      перейдут к владельцу клуба. Продолжить?
    </p>
  );

  if (mobile) {
    return (
      <HubSheet
        open={open}
        onClose={onCancel}
        title={title}
        footer={
          <HubSheetActions
            primary="Снять с группы"
            onPrimary={onConfirm}
            secondaryLabel="Отмена"
            onSecondary={onCancel}
          />
        }
      >
        {body}
      </HubSheet>
    );
  }

  return (
    <DesktopDialog
      open={open}
      onClose={onCancel}
      title={title}
      footer={
        <HubSheetActions
          primary="Снять с группы"
          onPrimary={onConfirm}
          secondaryLabel="Отмена"
          onSecondary={onCancel}
        />
      }
    >
      {body}
    </DesktopDialog>
  );
}
